import { render } from "./Reset.vue?vue&type=template&id=2264897c&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import "./Reset.vue?vue&type=style&index=0&id=2264897c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2264897c"],['__file',"webpack-assets/vue/templates/site/authorization/modal/Reset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2264897c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2264897c', __exports__)) {
    api.reload('2264897c', __exports__)
  }
  
  module.hot.accept("./Reset.vue?vue&type=template&id=2264897c&scoped=true", () => {
    api.rerender('2264897c', render)
  })

}


export default __exports__